/**
 * Checks if there's at least one successful Fannie or Freddie inspection submission
 * @param {Array} inspectionSubmissionsData - Array of inspection submission objects
 * @returns {boolean} - True if at least one successful Fannie or Freddie submission exists
 */
export const hasSuccessfulGseSubmission = (inspectionSubmissionsData) => {
  if (!inspectionSubmissionsData || !Array.isArray(inspectionSubmissionsData)) {
    return false
  }

  return inspectionSubmissionsData.some(
    (submission) => (submission.type === 'fannie' || submission.type === 'freddie') && submission.status === 'complete',
  )
}

/**
 * Returns all successful Fannie or Freddie inspection submissions
 * @param {Array} inspectionSubmissionsData - Array of inspection submission objects
 * @returns {Array} - Array of successful Fannie or Freddie submissions
 */
export const getSuccessfulGseSubmissions = (inspectionSubmissionsData) => {
  if (!inspectionSubmissionsData || !Array.isArray(inspectionSubmissionsData)) {
    return []
  }

  return inspectionSubmissionsData.filter(
    (submission) => (submission.type === 'fannie' || submission.type === 'freddie') && submission.status === 'complete',
  )
}
